import { render } from "./PanelView.vue?vue&type=template&id=57490072"
import script from "@/controllers/panelController.js?vue&type=script&lang=js"
export * from "@/controllers/panelController.js?vue&type=script&lang=js"

import "@/styles/panel.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__